import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { TaxRegime } from '../../../../interfaces/Sales/Catalogs/taxRegimes';
import GenericPromises from '../../../../api/GenericPromises';
import { Menuitem } from '../../../../interfaces/Security/menu';
import { Spinner } from '../../../../components/Commons/Spinner/Spinner';
import { Header } from '../../../../components/Header';
import { Button } from '@mui/material';
import { UpdateTaxRegimes } from './update';
import { usePermissions } from '../../../../hooks/usePermissions';
import { GenericDialog } from '../../../../components/Dialogs/Dialog';
import { ButtonStyled } from '../../../../theme/buttons';
import useSnackBar from '../../../../components/Commons/SnackBar/useSnackBar';

export const ViewTaxRegimes = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const navigate = useNavigate();
  const [taxRegimeLocal, setTaxRegimeLocal] = useState<TaxRegime>();
  const [openDialog, setOpenDialog] = useState(false);
  const [dataloaded, setDataLoaded] = useState(false);
  const { GenericGetResource, GenericDeleteResource } = GenericPromises();
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const { GetResourceByUrl } = usePermissions();


  const onDelete = () => {
    GenericDeleteResource(`/taxregimes/${taxRegimeLocal?.tax_regime_id}`)
      .then(() => {
        setOpenDialog(false);
        navigate("/taxregimes", { state: { method: "delete" }, replace: true });
      })
      .catch((error) => {
        showSnackBar(error.message, 'error');
        setOpenDialog(false);
      })
  }

  useEffect(() => {
    if (location.state === null) return navigate("/taxregimes", { state: {}, replace: true });
    GenericGetResource(`/taxregimes/${location.state.row.tax_regime_id}`)
      .then(
        (response) => {
          setTaxRegimeLocal(response.data);

          GetResourceByUrl(`/taxregimes`)
            .then((response1) => {
              setResourceScreen((prev) => response1);
              setDataLoaded(true);
            })
            .catch((error) => {
              showSnackBar(error.message, 'error');
            });
        }
      ).catch((error) => {
        showSnackBar(error.message, 'error');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <>
      {!dataloaded && <Spinner />}
      {dataloaded &&
        <div>
          <Header
            title={t("taxregimes.title-view")}
            child={
              <div className='d-flex flex-row-reverse m-1'>
                {resourceScreen?.delete === true &&
                  <ButtonStyled variant="contained" className="my-1" onClick={() => setOpenDialog(true)}>{t("generic.buttons.delete")}</ButtonStyled>
                }
                <Button variant="outlined" onClick={() => { navigate("/taxregimes", { replace: true }) }}>{t("generic.buttons.goback")}</Button>
              </div>
            }
          />

          <div>
            <UpdateTaxRegimes taxRegimePayload={taxRegimeLocal} isEdit={resourceScreen?.update} />
          </div>

          <GenericDialog
            title={t("generic.dialog.delete")}
            content={t("taxregimes.dialog.delete")}
            open={openDialog}
            setOpen={setOpenDialog}
            onAcept={onDelete}
          />
          <SnackbarComponent />
        </div>
      }
    </>
  )
}

